import React, { FC } from 'react'
import { UseQueryExecute } from 'urql'
import { Stack, Text } from '@chakra-ui/react'
import { rentals } from '@homevest/utils'
import { mapContentToBadge } from 'components/TailwindUIToolkit/badges'
import { CashoutSidebarFragment } from 'graphql/generated'
import Cashouts from 'screens/RentRoll/Details/Cashouts'
import { DocumentsCard } from 'screens/RentRoll/Details/Documents'
import Tenants from 'screens/RentRoll/Details/Tenants'

interface CashoutSidebarProps {
  rental: CashoutSidebarFragment
  refetch?: UseQueryExecute
}

export const Sidebar: FC<React.PropsWithChildren<CashoutSidebarProps>> = ({ rental, refetch }) => {
  return (
    <Stack fontSize='sm'>
      <Text textColor='neutral.900' fontSize='2xl'>
        {rental.portfolio_home?.home?.address?.display_line_1}
      </Text>
      <Text textColor='neutral.700'>{rental.portfolio_home?.home?.address?.display_line_2}</Text>
      <Text textColor='neutral.700'>{rental.property.most_recent_llc_property?.llc?.name}</Text>
      <div>
        {mapContentToBadge(rentals.RENTAL_PROGRAM_LEASE_TYPES[rental.rental_program_type], {
          dot: true,
          size: 'sm'
        })}
      </div>
      <Tenants rental={rental} />
      <Cashouts rental={rental} />
      <DocumentsCard
        rental={rental}
        refreshDocuments={() => refetch?.({ requestPolicy: 'network-only' })}
      />
    </Stack>
  )
}
